// added so later we can keep breakpoint in sync automatically using this config file
// import tailwindConfig from "../../tailwind.config.js"

import firebase from './../firebase/firebase';
import state from './state';

const getters = {

	// COMPONENT
		// vx-autosuggest
	// starredPages: state => state.navbarSearchAndPinList.data.filter((page) => page.highlightAction),
  windowBreakPoint: state => {

    // This should be same as tailwind. So, it stays in sync with tailwind utility classes
    if (state.windowWidth >= 1400) return "xl"
    else if (state.windowWidth >= 992) return "lg"
    else if (state.windowWidth >= 768) return "md"
    else if (state.windowWidth >= 576) return "sm"
    else return "xs"
  },

  isUserLoggedIn: (state) => !!state.AppActiveUser,
  
  isNewUser: (state) => state.isNewUser,

  getUserStoredData: (state) => {
    return state.AppActiveUser
  },

  getCompanyID : (state) => { return state.AppActiveUser && state.AppActiveUser.companyId },

  getCompanyInfo : (state) => { 
    return new Promise(resolve => {
      resolve(state.AppActiveCompany)
    })
  },

  getUserInfo: () => (uid) => {
    return new Promise( async (resolve, reject) => {
      try {
        const userInfo = await firebase.firestore().collection('user').doc(uid).get()
        resolve(userInfo.data() || null)
      } catch (err) {
        reject(err.message)
      }
    })
  },

  getFlashMessage : (state) => {
    return state.system.flashMessage;
  }

  /*getUserInfo: () => (uid) => {
    const ref = firebase.firestore().collectionGroup('companyUsers')
      .where('uid', '==', uid)
      
    return new Promise(
      function (resolve, reject) {
        
        ref.get().then(query => {
          query.forEach(doc => {
            let data = doc.data();
            data.companyId = query.docs[0].ref.parent.parent.id;
            resolve(data)
          })

          if(query.empty) {
            reject(false)
          }
        })
      }
    )
  }*/
}

export default getters
